export const queryKeys = {
  base: ['fax'] as const,
  faxHistory: (query?: string) => [...queryKeys.base, 'faxHistory', query],
};
